import {ServiceProviderRepository} from '../repository/ServiceProviderRepository';
import {ServiceProvider} from '../models/serviceProvider.model';

export class CreateServiceProviderUseCase {
  constructor (private serviceProviderRepository: ServiceProviderRepository) {}

  async execute (providerData: Omit<ServiceProvider, 'id' | 'status' | 'createdAt' | 'updatedAt'> & { password: string }): Promise<ServiceProvider> {
    return await this.serviceProviderRepository.create(providerData);
  }
}
